import { Pipe, PipeTransform } from '@angular/core';
import { secondsToDhms } from '../helpers';

@Pipe({
    name: 'secsToDhms'
})

export class SecsToDhmsPipe implements PipeTransform {
    transform(seconds: number): string {
        let result = secondsToDhms(seconds);
        return result;
    }
}

